import React, {
    useState,
    useEffect,
    useRef,
    useCallback,
    useLayoutEffect,
} from 'react'
import { Okpd2 } from '../../../../../Org/Handbook/types'
import { OrganizationInfo } from '../../../../../Org/Home/types'

import { ContractPerformance, Country } from '../../../../types'
import { CurrencyList } from '../../../types'

import { ContractPosition } from '../../../../types'

import { PerformanceContractDocPositionItem } from '../../types'

import LoadingIcon from '../../../../../../../components/LoadingIcon'
import HoverTooltip from '../../../../../../../components/HoverTooltip'

import { NumericFormat } from 'react-number-format'

const formatNumber = (num: number | string | null | undefined): string => {
    if (num === null || num === undefined) return '-' // Обрабатываем пустые значения

    const parsedNum = typeof num === 'number' ? num : parseFloat(num)

    if (isNaN(parsedNum)) {
        return '-' // Обрабатываем некорректные значения
    }

    return parsedNum
        .toFixed(2) // Два знака после запятой
        .replace(/\B(?=(\d{3})+(?!\d))/g, ' ') // Разделяем тысячные пробелами
        .replace('.', ',') // Заменяем точку на запятую
}

type Props = {
    theme: string
    contractPosition: ContractPosition
    currencyList: CurrencyList[]
    selected: boolean
    onClick: (contract_position_guid: string) => void
    onRightClick: (contract_position_guid: string) => void
}

const PerformanceDocsAddFromContractPopupTableRow: React.FC<Props> = (
    props
) => {
    return (
        <div
            className="flex flex-col w-full "
            onClick={() => props.onClick(props.contractPosition.guid ?? '')}
        >
            {/* строка документа */}
            <div
                className={
                    props.selected
                        ? 'plan-position-table-row-selected p-1 items-start justify-center cursor-default'
                        : 'plan-position-table-row p-1 items-start justify-center cursor-default'
                }
            >
                <div className="flex w-8 h-full items-start justify-center text-center cursor-pointer">
                    <HoverTooltip tooltipText="Выбрать строку">
                        <input
                            type="checkbox"
                            className="flex h-[28px] cursor-pointer"
                            checked={props.selected}
                            onClick={(e) => e.stopPropagation()}
                            onChange={() => {
                                props.onClick(props.contractPosition.guid ?? '')
                            }}
                        />
                    </HoverTooltip>
                </div>
                <div className="flex w-10 h-[28px] items-center justify-center text-[#6A6A6A] dark:text-[#8A8A8A]">
                    {props.contractPosition.ordinal_number}
                </div>
                <HoverTooltip
                    tooltipContent={
                        props.contractPosition.contract_position_name
                    }
                    align="right"
                    valign="bottom"
                >
                    <div className="flex flex-1 items-center justify-start text-[#181818] dark:text-[#FFFFFF] ">
                        <div className="flex min-h-[28px] w-full p-1 px-2 rounded-md text-[11px] items-center text-[#181818] dark:text-[#FFFFFF] ">
                            {props.contractPosition.contract_position_name}
                        </div>
                    </div>
                </HoverTooltip>
                <div className="flex w-[100px] items-center justify-start text-[#181818] dark:text-[#FFFFFF] ">
                    <div className="flex min-h-[28px] w-full p-1 px-2 rounded-md text-[11px] items-center justify-center text-[#181818] dark:text-[#FFFFFF] ">
                        {props.contractPosition.okei_name}
                    </div>
                </div>
                <div className="flex w-[100px] items-center justify-start text-[#181818] dark:text-[#FFFFFF] ">
                    <div className="flex min-h-[28px] w-full p-1 px-2 rounded-md text-[11px] items-center justify-center text-[#181818] dark:text-[#FFFFFF] ">
                        {props.contractPosition.qty}
                    </div>
                </div>
                <div className="flex w-[100px] items-center justify-start text-[#181818] dark:text-[#FFFFFF] ">
                    <div className="flex min-h-[28px] w-full px-2 rounded-md text-[11px] items-center justify-end text-[#181818] dark:text-[#FFFFFF]">
                        {formatNumber(props.contractPosition.unit_price)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PerformanceDocsAddFromContractPopupTableRow
